import styled from 'styled-components';

const Name = styled.p`
  ${({ theme }) => theme.fontFamily.secondaryFont.smallBold}
  margin: 0;
  line-height: 1.29;
`;

export default Name;
